const formatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

const resolveShare = (sumOfAllItems: number, selectedItemValue: number) => {
  const shareValue = sumOfAllItems === 0 ? 0 : selectedItemValue / sumOfAllItems

  return shareValue < 0.01 && shareValue > 0 ? '<1%' : formatter.format(shareValue)
}

export default resolveShare
